import React, { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@mui/material/Alert';
import WarningIcon from '@mui/icons-material/WarningRounded';
import InfoIcon from '@mui/icons-material/Info';
import { Button } from 'components/Shared/Inputs';
import { useCredentialing } from '../../Tabs/Credentialing/CredentialingContext';

import './LiabilityInsurance.scss';

export const LiabilityInsuranceAlert: FC = () => {
    const { t } = useTranslation(['providerprofile']);
    const { isInsuranceDocumentExpiring, isInsuranceDocumentExpired, handleLiabilityInsuranceRenew } = useCredentialing();

    return isInsuranceDocumentExpiring || isInsuranceDocumentExpired ?
    (
        <Alert 
            className="expiry_license_warning" 
            variant="standard" 
            color={isInsuranceDocumentExpired ? "warning" : "info"}
            icon={isInsuranceDocumentExpired ? <WarningIcon color="warning" /> : <InfoIcon color="primary" />}
        >
            <div className="alert-content">
                <div className="alert-text">
                    <div className="message-line">
                        <div className="message">
                            {isInsuranceDocumentExpiring ? t("liability_insurance__is_expiring") : ""}
                            {isInsuranceDocumentExpired ? t("liability_insurance__has_expired") : ""}
                        </div>
                    </div>
                    <div className="instruction">
                        {t('liability_insurance__clicking_renew')}
                    </div>
                </div>
                <Button 
                    variant="text" 
                    size="small" 
                    onClick={handleLiabilityInsuranceRenew}
                    className="renew-button"
                >
                    {t('common:renew')}
                </Button>
            </div>
        </Alert>
    ) : <></>;
}
